import { ButtonComponent } from '../ButtonComponent';
import React, { FC, useState } from 'react';
import clsx from 'clsx';
import { Popover, Whisper } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { checkIfValidUUID, validateEmail } from '../../layout/core';
import { useTranslation } from 'react-i18next';

interface Props {
	fieldLabel: string;
	value: string | number;
	setValue: (value: string) => void;
	close: () => void;
	open: () => void;
	reference: any;
	type: 'text' | 'number';
	isLoading?: boolean;
	isGuid?: boolean;
	isNumber?: boolean;
	isEmail?: boolean;
	isBin?: boolean;
	isLast4?: boolean;
	setIsRefreshed?: (value: boolean) => void,
}

export const NumberFilterComponent: FC<Props> = (props) => {
	const { t } = useTranslation();

	const {
		fieldLabel,
		reference,
		open,
		close,
		value,
		setValue,
		type,
		isLoading,
		isGuid,
		isNumber,
		isEmail,
		isBin,
		isLast4,
		setIsRefreshed
	} = props;

	const [currentValue, setCurrentValue] = useState<string>('');
	const [isError, setIsError] = useState<boolean>(false);

	const isValidId = checkIfValidUUID(currentValue);

	const handleValueSave = (): void => {
		const binLength = currentValue.length === 6 || currentValue.length === 8;
		if (
			(currentValue && type === 'number' && currentValue.includes('e'))
			|| !currentValue
			|| (isGuid && !isValidId)
			|| (isEmail && !validateEmail(currentValue))
			|| (isBin && !binLength)
			|| (isLast4 && currentValue.length !== 4)
		) {
			setIsError(true);
			return;
		}
		if (setIsRefreshed !== undefined) {
			setIsRefreshed(false);
		}
		setValue(currentValue);
		setCurrentValue('');

		close();
	};

	const handleClean = (): void => {
		!isLoading && setValue(null);
		if (setIsRefreshed !== undefined) {
			setIsRefreshed(false);
		}
	};

	const getErrorText = (): string => {
		if (isGuid) return 'Please enter valid id';
		if (isNumber) return 'Please enter valid number';
		if (isEmail) return 'Please enter valid email';
		if (isBin) return t('ORDERS.VALIDATION.BIN_ERROR');
		if (isLast4) return t('ORDERS.VALIDATION.LAST_4_ERROR');
		return `Please enter ${fieldLabel}`;
	};

	const speaker = (
		<Popover title={fieldLabel}>
			<div className="fv-row input-container">
				<input
					type={type}
					placeholder='Enter value'
					className="form-control form-control-xs form-control-solid mb-7 mt-1 number-input-zip"
					value={currentValue}
					onChange={(e): void => {
						setIsError(false);
						setCurrentValue(e.target.value);
					}}
				/>
				{isError && (
					<div className="position-absolute error-text-position text-danger fs-9">
						{getErrorText()}
					</div>
					)
				}

				<ButtonComponent
					buttonName="Apply"
					additionalClass="btn-sm no-letter-spacing py-2 d-block w-100"
					onButtonClick={handleValueSave}
				/>
			</div>
		</Popover>
	);

	return (
		<div className={clsx(isLoading && 'cursor-not-allowed')}>
			<Whisper
				placement="bottom"
				speaker={speaker}
				ref={reference}
				trigger="click"
				disabled={isLoading}
			>
				<div
					className={clsx(
						'fs-9 text-filter-styles',
						value ? 'pe-5 not-disputed-text-color' : 'fc-added-icon ps-6 placeholder-color',
						isLoading ? 'cursor-not-allowed disputed-text-color' : 'cursor-pointer'
					)}
					onClick={():void => !isLoading && open()}
				>
					{value ? value : fieldLabel}
				</div>
			</Whisper>
			{
				value && (
					<div
						className={clsx(
							'delete-icon me-2 position-absolute',
							isLoading ? 'cursor-not-allowed' : 'cursor-pointer'
						)}
						onClick={handleClean}
					>
						<FontAwesomeIcon icon={faXmark} width={14} height={14}/>
					</div>
				)
			}
		</div>
	);
};
